import React, { Component } from "react";
import { CallAPI, GetCookieFunction, parseIntFromStr } from '../../utils/util';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();
        return <Component {...props} router={{ location, navigate, params, searchParams }} />;
    }
    return ComponentWithRouterProp;
}

class Medication extends Component {
    constructor(props) {
        super(props);
        this.patient_id = parseIntFromStr(this.props.router.params.patientId);
        this.user_type = (GetCookieFunction("User")?.type === "doctor") ? "doctor" : "nurse";
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
        this.state = { rows: [], patientID: this.patient_id };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.patient_id}/medications`, 'GET', (res) => {
            this.setState({ rows: res.length > 0 ? res : [] });
        });
    }

    onAddRow = () => {
        this.setState({ rows: [...this.state.rows, { id: 0, name: "", dose: "", interval: "", delete: false }] });
    };

    onDeleteRow = (index) => {
        this.setState({
            rows: this.state.rows.map((row, i) => i === index ? { ...row, delete: true } : row)
        });
    };

    onFieldChange = (index, field, value) => {
        this.setState({
            rows: this.state.rows.map((row, i) => i === index ? { ...row, [field]: value } : row)
        });
    };

    onSave = () => {
        if (this.state.rows.length === 0) {
            if (this.funnel) this.props.router.navigate(`/patients/${this.patient_id}/surgeries${this.funnel}`);
            return;
        }
        CallAPI(this.state, `patients/${this.patient_id}/medications`, 'PUT', () => {
            if (this.funnel) {
                this.props.router.navigate(`/patients/${this.patient_id}/surgeries${this.funnel}`);
            } else {
                CallAPI({}, `patients/${this.patient_id}/medications`, 'GET', (res) => {
                    this.setState({
                        rows: res.length > 0 ? res : [],
                        modalVariant: "success",
                        modalMessage: "Medications saved successfully."
                    });
                });
            }
        }, () => {
            this.setState({ modalVariant: "danger", modalMessage: "Could not save medications." });
        });
    };

    render = () => {
        const visibleRows = this.state.rows.filter(r => !r.delete);

        return (
            <div>
                <PatientNav patientId={this.patient_id} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.patient_id} currentStep={6} />}
                    <div className="ci-header">
                        <h2>Medications</h2>
                        <p>Record and manage current patient medications</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <div className="editable-table-wrap">
                        {/* Desktop header — hidden on mobile via CSS */}
                        <div className="editable-table-header med-header">
                            <div className="editable-col-med-name">Medication</div>
                            <div className="editable-col-med-sub">Dose</div>
                            <div className="editable-col-med-sub">Frequency</div>
                            <div className="editable-col-action"></div>
                        </div>

                        {visibleRows.length === 0 ? (
                            <div className="editable-empty">
                                No medications on file. Click "Add Medication" to add one.
                            </div>
                        ) : (
                            visibleRows.map((row, i) => {
                                const realIndex = this.state.rows.indexOf(row);
                                return (
                                    <div key={i} className="editable-table-row med-row">
                                        {/* Medication name — full width on all screens */}
                                        <div className="editable-col-med-name">
                                            <label className="med-mobile-label">Medication</label>
                                            <input
                                                type="text"
                                                placeholder="e.g. Erythropoietin"
                                                value={row.name}
                                                onChange={(e) => this.onFieldChange(realIndex, 'name', e.target.value)}
                                            />
                                        </div>
                                        {/* Dose + Frequency — side by side on narrow, inline on wide */}
                                        <div className="editable-col-med-sub">
                                            <label className="med-mobile-label">Dose</label>
                                            <input
                                                type="text"
                                                placeholder="e.g. 4000 IU"
                                                value={row.dose}
                                                onChange={(e) => this.onFieldChange(realIndex, 'dose', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-med-sub">
                                            <label className="med-mobile-label">Frequency</label>
                                            <input
                                                type="text"
                                                placeholder="e.g. 3x per week"
                                                value={row.interval}
                                                onChange={(e) => this.onFieldChange(realIndex, 'interval', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-action">
                                            <button
                                                type="button"
                                                className="editable-delete-btn"
                                                onClick={() => this.onDeleteRow(realIndex)}
                                                aria-label="Delete"
                                            >✕</button>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>

                    <div className="editable-actions">
                        <button type="button" className="homeButton" onClick={this.onAddRow}>
                            + Add Medication
                        </button>
                        <button type="button" className="logSubmit" onClick={this.onSave}
                            style={{ width: 'auto', marginTop: 0 }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(Medication);
